import { Grid, Typography } from "@mui/material";
import ContentBox from "src/components/ContentBox/ContentBox";
import { successFullSwap } from "src/media/texts/faq_main";
import { textStyle } from "src/styles/textstyle";
import { AccordionWrapper } from "../../MainPage/Components/StillUnsure";

export default function GeneralInfo() {
  return (
    <ContentBox title="General info" id={"good-advice-1"}>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Typography
            variant="h3"
            sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
          >
            Good advices for a successful swap
          </Typography>
          {/* </Grid> */}
          <Grid item xs={12} md={8}>
            {successFullSwap.map((item, index) => (
              <AccordionWrapper
                key={index}
                question={index + 1 + ". " + item.header}
                answer={item.answer}
                smallVersion={true}
              />
            ))}
          </Grid>
        </Grid>
      </Grid>
    </ContentBox>
  );
}
